import { IconButton } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: '1rem';
`

export const CustomButton = styled(ButtonMui)`
  width: 16rem;
`

export const DivIconButton = styled.div`
  width: 21px;
  height: 21px;
`

export const CustomIconButton = styled(IconButton)`
  width: 21px;
  height: 21px;
  cursor: pointer;
`

export const BodyModalAlert = styled.div`
  display: flex;
  width: 100%;
  margin: 1rem;
`

export const AlertMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  word-wrap: break-word;
`

export const AlertMessage = styled.span`
`
